import React from 'react';
import '../styles/Loader.css';


function Loader(){

    return(
        <>
        <div className="loader-line">hello</div>
        </>
    )
}

export default Loader;

